import { useState, useEffect } from "react";
import { ethers } from "ethers";

const provider = new ethers.providers.JsonRpcProvider(
  import.meta.env.VITE_RPC_URL,
);

const useContractRead = (
  contractAddress: string,
  contractABI: any[],
  functionName: string,
  args: any[] = [],
) => {
  const [data, setData] = useState<unknown>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const callFunction = async () => {
      console.log(`useContractRead invoked`);
      setIsLoading(true);
      setError(null);
      try {
        const contractInstance = new ethers.Contract(
          contractAddress,
          contractABI,
          provider,
        );
        const result = await contractInstance[functionName](...args);
        setData(result);
      } catch (err: any) {
        console.log("check errrrrr---", functionName, args, err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };
    callFunction();
  }, [JSON.stringify(args)]);

  return { data, isLoading, error };
};

export default useContractRead;
